module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.7fa03c32.svg";